import React, { memo, useMemo, useCallback } from 'react';
import classNames from 'classnames/bind';
import styles from './MajorOptionList.module.scss';

const cx = classNames.bind(styles);

/**
 * 주요옵션 리스트 공통 컴포넌트
 * @param {Object} props
 * @param {string} props.vehicleType - 차량 타입 ('CAR' | 'TRUCK')
 * @param {Array<string>} props.standardOptions - 차량에 장착된 옵션 코드 배열
 * @param {string} [props.className] - 추가 클래스명
 */
function MajorOptionList({ vehicleType = 'CAR', standardOptions = [], className = '' }) {
	const optionUse = useCallback((value) => standardOptions?.indexOf(value) > -1, [standardOptions]);

	const optionListCar = useMemo(
		() => [
			{
				use: optionUse('010'),
				icon: 'icon1',
				text: '선루프',
			},
			{
				use: optionUse('029') || optionUse('075'),
				icon: 'icon2',
				text: `헤드램프${optionUse('075') ? '\n(LED)' : '\n(HID)'}`,
			},
			{
				use: optionUse('085') || optionUse('032'),
				icon: 'icon3',
				text: '주차감지센서',
			},
			{
				use: optionUse('058'),
				icon: 'icon4',
				text: '후방카메라',
			},
			{
				use: optionUse('023'),
				icon: 'icon5',
				text: '자동에어컨',
			},
			{
				use: optionUse('057'),
				icon: 'icon6',
				text: '스마트키',
			},
			{
				use: optionUse('005'),
				icon: 'icon7',
				text: '내비게이션',
			},
			{
				use: optionUse('022') || optionUse('063'),
				icon: 'icon8',
				text: '열선시트',
			},
			{
				use: optionUse('034') || optionUse('077'),
				icon: 'icon9',
				text: '통풍시트',
			},
			{
				use: optionUse('014'),
				icon: 'icon10',
				text: '가죽시트',
			},
		],
		[optionUse],
	);

	const optionListTruck = useMemo(
		() => [
			{
				use: optionUse('001'),
				icon: 'icon11',
				text: '리프트',
			},
			{
				use: optionUse('026'),
				icon: 'icon4',
				text: '후방카메라',
			},
			{
				use: optionUse('034'),
				icon: 'icon7',
				text: '내비게이션',
			},
			{
				use: optionUse('014'),
				icon: 'icon10',
				text: '가죽시트',
			},
			{
				use: optionUse('019'),
				icon: 'icon12',
				text: 'ABS',
			},
		],
		[optionUse],
	);

	const renderOptionList = (data) =>
		data.map((v) => (
			<li
				key={v.icon}
				className={cx({ on: v.use })}
			>
				<span className={cx('icon', v.icon)} />
				{v.text} <span className="blind">{v.use ? '있음' : '없음'}</span>
			</li>
		));

	const optionData = vehicleType === 'TRUCK' ? optionListTruck : optionListCar;

	return <ul className={cx('list_option', className)}>{renderOptionList(optionData)}</ul>;
}

export default memo(MajorOptionList);
